// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"97f3e4f6","239":"2315982d","455":"210fb159"}[chunkId] + ".chunk.js";
};